import React, {useState} from 'react';

import CollapserThing from './CollapserThing';
import {FAQPage} from './LinkedData';

/**
 * A single question and answer pair to include within a list of FAQs
 * @param {object} item
 * @param {string|JSX} item.question Question string
 * @param {string|JSX} item.answer Answer string
 */
const QuestionAndAnswer = ({item}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="FAQs__question text-left"
        onClick={() => setOpen(!open)}
        type="button"
      >
        {item.question}
        <i className={`FAQs__arrow ${open ? 'FAQs__arrow--rotated' : ''}`} />
      </button>
      <CollapserThing visible={open}>
        <div className="FAQs__answer text-left">
          {item.answer}
        </div>
      </CollapserThing>
    </>
  );
};

/**
 * @param {array} items Array of {question: '', answer: ''} objects
 * @param {boolean} includeMetadata Add FAQPage structured data for SEO https://developers.google.com/search/docs/advanced/structured-data/faqpage
 */
const FAQs = ({items = [], includeMetadata = false}) => (
  <div className="FAQs">
    {includeMetadata && <FAQPage items={items} />}
    {items.map((item) => (
      <QuestionAndAnswer item={item} />
    ))}
  </div>
);

export default FAQs;
